module.exports = __webpack_public_path__ + "aaf60a86b259ed6a8ca82aea8d56b502.png";